import React, { useLayoutEffect, useState } from 'react';
import { getCtaUrl } from '../../../utils';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import GlobalImage from '../Image/GlobalImage';
import closeButton from '../../Icons/close.svg';

import './index.scss';

const TopMessage = ({ data }) => {
  const location = useLocation();

  const [toggleTopMessage, setToggleTopMessage] = useState(true);
  const [showTopMessageAccordingSession, setShowTopMessageAccordingSession] = useState(true);

  useLayoutEffect(() => {
    const stored = sessionStorage.getItem('show_top_message');
    if (stored !== null) {
      setShowTopMessageAccordingSession(stored === 'true');
    }
  }, []);

  useLayoutEffect(() => {
    const navbar = document.querySelector('.ui-navbar');
    const topMessage = document.querySelector('.top-message-container');

    const updateNavbarOffset = () => {
      if (!navbar || !topMessage) return;
      requestAnimationFrame(() => {
        const height = topMessage.offsetHeight || 0;
        navbar.style.top = `${height}px`;
      });
    };

    updateNavbarOffset();

    window.addEventListener('resize', updateNavbarOffset);

    const handleRouteChange = () => {
      setTimeout(updateNavbarOffset, 50);
    };
    window.addEventListener('gatsby-route-change-complete', handleRouteChange);

    return () => {
      window.removeEventListener('resize', updateNavbarOffset);
      window.removeEventListener('gatsby-route-change-complete', handleRouteChange);
    };
  }, []);

  const handleToggleTopMessage = () => {
    setToggleTopMessage((prev) => {
      const next = !prev;
      sessionStorage.setItem('show_top_message', next);
      return next;
    });
  };

  if (!toggleTopMessage || !showTopMessageAccordingSession) return null;

  return (
    <div className="top-message-container" data-datocms-noindex>
      <div className="d-flex h-100 align-items-center justify-content-center">
        <span className="information">
          <GlobalImage image={data.icon} role="presentation" />
          <span className="information-message" dangerouslySetInnerHTML={{ __html: data.message }} />
          {data.link?.label && (
            <Link to={getCtaUrl(data)} className="information-link">
              {data.link.label}
            </Link>
          )}
        </span>

        <button className="close-btn" onClick={handleToggleTopMessage} aria-label="Close message">
          <img src={closeButton} alt="" role="presentation" />
        </button>
      </div>
    </div>
  );
};

export default TopMessage;
